import { useCallback } from "react";
import z from "zod";
import { getMessageMediaApiUrl } from "../../../config/config";
import { useFetchData } from "../../../hooks/useFetchData";
import type { INTEGRATION_LIST } from "../components/constants";

export type Integrations = (typeof INTEGRATION_LIST)[number];

const connectionStateZod = z
  .object({
    store_id: z.string(),
    state: z.union([z.literal("CONNECTED"), z.literal("COMPLETED")]),
  })
  .deepPartial();
export type IntegrationConnectionState = z.infer<typeof connectionStateZod>;

export const useValidateConnection = (
  integration: Integrations,
  isEnabled: boolean
) => {
  const dataParser = useCallback((data: unknown) => {
    const parsed = connectionStateZod.safeParse(data);
    if (parsed.success) return parsed.data;
    return data as Partial<IntegrationConnectionState>;
  }, []);

  const { data } = useFetchData(
    `${getMessageMediaApiUrl()}/v1/bff/integrations/platforms/${integration}/connection`,
    dataParser,
    {
      withToken: true,
      autoFetch: isEnabled,
    }
  );

  return data;
};
